import { Step } from "../../types/Step";
import { TariffaSingola } from "../../types/TariffaSingola";
import { EngineState, Selections } from "./engine.types";

// @ritorna le selezioni da annullare quando torno allo step indicato
const cancelSelectionsFrom = (step: Step): Partial<TariffaSingola> => {
  switch (step) {
    case Step.COSA:
      return {
        vivere: undefined,
        muoversi: undefined,
        dipendente: undefined,
        famiglia: true,
      };
    case Step.SCONTO:
      return {};
  }
};

export const nextStep = (step: Step): Step => {
  switch (step) {
    case Step.COSA:
      return Step.SCONTO;
    case Step.SCONTO:
      return Step.COSA; // Si ricominicia da capo! Introdurre un nuovo stato?
    default:
      return step;
  }
};

// Ritorna il prossimo Step sulla base delle scelte obbligate passate
export const nextStepInProcess = (s: Selections): Step => {
  let newStep = Step.COSA;
  if (s.vivere !== undefined && s.muoversi !== undefined && s.dipendente !== undefined) {
    newStep = nextStep(newStep);
  }
  return newStep;
};

// @return aggiornamento di stato con avanzamento step (solo se dati completi)
export const nextStepEngineState = (state: EngineState, newSelections: Selections): EngineState => {
  const step = nextStepInProcess(newSelections);
  const prevSteps: Step[] = step !== state.step ? [...state.prevSteps, state.step] : state.prevSteps;
  return {
    ...state,
    selections: newSelections,
    step,
    prevSteps,
  };
};

// @return aggiornamento di stato senza avanzamento di step
export const updateEngineState = (state: EngineState, newSelections: Selections): EngineState => {
  const selections = { ...newSelections };
  return {
    ...state,
    selections,
  };
};

// @return aggiornamento di stato per bottone indietro
export const backStepEngineState = (state: EngineState): EngineState => {
  const prevSteps = [...state.prevSteps];
  const step = prevSteps.pop();
  if (step !== undefined) {
    return {
      ...state,
      step,
      prevSteps,
      selections: { ...state.selections, ...cancelSelectionsFrom(step) },
    };
  }
  return state;
};

// @return aggiornamento di stato per azione BACK_TO_STEP step
export const backToStepEngineState = (state: EngineState, step: Step): EngineState => {
  const prevSteps = state.prevSteps.slice(0, state.prevSteps.indexOf(step));
  return {
    ...state,
    step,
    prevSteps,
    selections: { ...state.selections, ...cancelSelectionsFrom(step) },
  };
};
